<template>
  <section class="app-main">
    <Navbar/>
    <div class="app-main-cotent">
      <transition name="fade-transform" mode="out-in">
        <keep-alive :include="cachedViews">
          <router-view :key="key" />
        </keep-alive>
      </transition>
    </div>
  </section>
</template>

<script>
import Navbar from './Navbar'
export default {
  name: 'AppMain',
  components: {
    Navbar
  },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    }
  },
  data() {
    return {
      interval: null,
      isbeforeDestroy: false
    }
  },
  mounted() {
    this.isbeforeDestroy = false
    window.addEventListener('keyup', () => {
        this.refreshLoginToken()
    })
    window.addEventListener('scroll', () => {
      this.refreshLoginToken()
    })
    window.addEventListener('mousemove', () => {
      this.refreshLoginToken()
    })
    window.addEventListener('mousedown', () => {
      this.refreshLoginToken()
    })
    this.checkRefreshLoginToken()
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.isbeforeDestroy = true;
  },
  methods: {
    refreshLoginToken () {
      this.$store.dispatch('user/lastOperationTime')
    },
    checkRefreshLoginToken () {
      this.interval = setTimeout(() => {
          if (this.isbeforeDestroy) {
            return;
          }

          //距离最后一次操作时间在大于token 失效时间外就不自动刷新token
          let time = new Date().getTime()
          time = time / 1000

          if (this.$store.state.user.tokenExpireTime < time) {
            this.$confirm('登录过期，请重新登录', {
              confirmButtonText: '确定',
              showClose: false,
              type: 'warning'
            }).then(() => {
              this.$store.dispatch('user/resetToken')
              this.$router.push({path:'/login'})
            });
            return
          }

          //10 分钟外部用刷新
          if (this.$store.state.user.tokenExpireTime - this.$store.state.user.lastOperationTime > 60 * 20) {
            this.checkRefreshLoginToken()
            return
          }

          this.$store.dispatch('user/refreshToken').then(res => {
            this.checkRefreshLoginToken()    
          }, () => {
            this.checkRefreshLoginToken()
          });
        }, 1000);
    }
  }
}
</script>

<style lang="scss">
.app-main {
  /* 50= navbar  50  */
  width: 100%;
  position: relative;
  padding: 20px;
  height: 100%;
}

.app-main-cotent {
  width: 100%;
  padding: 20px;
  margin: 15px 20px 0 0;
  background: #fff;
  min-height: calc(100% - 31px);
}

.nosidebar .app-main-cotent {
  background:none; 
  margin: 0;
  padding: 0;
}

.fixed-header+.app-main {
  padding-top: 61px;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
